module.exports = __webpack_public_path__ + "assets/media/arrow.667c01ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/MeetingsBookedPreview/arrow.svg
// module id = 2605
// module chunks = 0